import { createSelector } from '@reduxjs/toolkit';
import { unread_news_selector } from 'console/redux/news/selectors';
export const unread_count_selector = createSelector(unread_news_selector, (state) => state.important_events, (news_cnt, important_events) => news_cnt + important_events.unread);
